import React from "react"

function Navbar({ activeCert, setActiveCert }) {
  const handleTabClick = (certId) => {
    if (certId === "admin1" || certId === "admin2" || certId === "app-builder" || certId === "business-analyst" || certId === "developer1") {
      setActiveCert(certId)
    }
  }

  return (
    <div className="navbarContainer">
      <img src="/certforcep.webp" alt="Certforce Logo" className="logo"></img>

      <div className="tabs">
        <div
          className={`certTab ${activeCert === "admin1" ? "active" : ""}`}
          onClick={() => handleTabClick("admin1")}
        >
          <div>Platform Administrator</div>
        </div>

        <div
          className={`certTab ${activeCert === "admin2" ? "active" : ""}`}
          onClick={() => handleTabClick("admin2")}
        >
          <div>Platform Administrator II</div>
        </div>

        <div
          className={`certTab ${activeCert === "app-builder" ? "active" : ""}`}
          onClick={() => handleTabClick("app-builder")}
        >
          <div>Platform App Builder</div>
        </div>

        <div
          className={`certTab ${activeCert === "business-analyst" ? "active" : ""}`}
          onClick={() => handleTabClick("business-analyst")}
        >
          <div>Business Analyst</div>
        </div>

        <div
          className={`certTab ${activeCert === "developer1" ? "active" : ""}`}
          onClick={() => handleTabClick("developer1")}
        >
          <div>Developer I</div>
        </div>
      </div>
    </div>
  )
}

export default Navbar
